
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {mask} from "vue-the-mask";

@Component({
  directives: {
    mask,
  },
})
export default class Dates extends Vue {
  @Prop({}) value!: string;
  /**
   * v-model'in taşıdığı biçim. Varsayılan 'iso' (YYYY-MM-DD) tüm mevcut kullanımların
   * sözleşmesidir. UYAP alanları tarihi GG/AA/YYYY metni olarak taşıdığı ve bu metin
   * doğrudan UYAP'a gönderildiği için, o alanlarda 'uyap' verilerek giriş/çıkış bu
   * biçimde yapılır; bileşenin içi (v-date-picker) yine ISO ile çalışır.
   */
  @Prop({default: 'iso'}) valueFormat!: 'iso' | 'uyap';
  @Prop({}) label!: string;
  @Prop({}) placeHolder!: string;
  @Prop({}) type!: string;
  @Prop() color!: string;
  @Prop({default: true}) clearable!: boolean;
  @Prop({}) rules!: string;
  @Prop({default: false}) range!: boolean;
  @Prop({}) reverse!: any;
  @Prop({}) readonly!: boolean;
  @Prop({}) minDate!: Date;
  @Prop({}) maxDate!: Date;
  @Prop({}) dense !: string | boolean;
  @Prop({}) hideIcon !: string | boolean;
  @Prop({}) aciklama!: string;
  @Prop({}) persistentHint!: any;
  @Prop({}) hideDetails!: string | boolean;
  @Prop() error !: boolean;
  @Prop() errorMessages !: string;

  menu: boolean = false;
  mask = "##.##.####";
  pickerValue: string | null = this.valueToIso(this.value);
  textFieldValue: string = "";

  get rule() {
    if (this.type === 'year') {
      return [];
    }
    if (this.textFieldValue) {
      if (this.textFieldValue.length == 10) {
        if (this.textFieldValue.match(/^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/) !== null) {
          if (this.rules)
            return this.rules;
          else
            return [true]
        }
        else return ['Yanlış tarih bilgisi.']
      } else
        return ['Eksik tarih bilgisi'];
    }
    else{
      if(this.rules)
        return this.rules;
      else return [true]
    }
  }

  get isReverse() {
    return this.reverse || this.reverse === "";
  }

  get isPersistentHint() {
    return this.persistentHint || this.persistentHint === "";
  }

  get isHideDetails() {
    return this.hideDetails || this.hideDetails === "";
  }

  get isDense() {
    return this.dense || this.dense === "";
  }

  get isHideIcon() {
    return this.hideIcon || this.hideIcon === "";
  }

  @Watch("value")
  onValueChanged() {
    this.pickerValue = this.valueToIso(this.value);
    this.onPickerValueChanged();
  }

  @Watch("pickerValue")
  onPickerValueChanged() {
    this.textFieldValue = this.pickerValue ? this.formatToText(this.pickerValue) : "";
    this.save();
  }

  @Watch("textFieldValue")
  onTextFieldValueChanged() {
    if (this.textFieldValue == null || this.textFieldValue == '') {
      this.pickerValue = null;
    } else if (this.textFieldValue.length == 10) {
      this.pickerValue = this.formatToDate(this.textFieldValue);
    }
    this.save();
  }

  mounted() {
    this.onPickerValueChanged();
  }

  formatToText(date: string): string {
    if (!date) return "";
    if (this.type === "year") {
      return date.split("-")[0]; // Only show the year
    }
    return date
      .split("-")
      .reverse()
      .join(".");
  }

  formatToDate(date: string): string {
    if (!date) return "";
    if (this.type === "year") {
      return `${date}-01-01`; // Set month and day to January 1st
    }
    return date
      .split(".")
      .reverse()
      .join("-");
  }

  /**
   * Dışarıdan gelen değeri picker'ın kullandığı ISO biçimine çevirir.
   * Çözümlenemeyen değerde null döner; eskiden `new Date(...).toISOString()` geçersiz
   * tarihte RangeError atıp bileşeni komple çökertiyordu.
   */
  valueToIso(deger: any): string | null {
    if (!deger)
      return null;
    if (this.valueFormat === 'uyap') {
      // GG/AA/YYYY veya GG.AA.YYYY; XML'den tek haneli gün/ay da gelebiliyor.
      const parcalar = String(deger).trim().match(/^(\d{1,2})[./](\d{1,2})[./](\d{4})$/);
      if (!parcalar)
        return null;
      return parcalar[3] + "-" + parcalar[2].padStart(2, "0") + "-" + parcalar[1].padStart(2, "0");
    }
    const tarih = new Date(deger);
    return isNaN(tarih.getTime()) ? null : tarih.toISOString().substr(0, 10);
  }

  /** Picker'ın ISO değerini v-model'in beklediği biçime çevirir. */
  isoToValue(iso: string): string {
    return this.valueFormat === 'uyap' ? iso.split("-").reverse().join("/") : iso;
  }

  save() {
    this.$emit("input", this.pickerValue ? this.isoToValue(this.pickerValue) : null);
    this.menu = false;
  }
}
